import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";

import Headings from "../Component/SalaryCalculation/Headings";
// Ef
import YearsGrossMargin from "../Component/SalaryCalculation/YearsGrossMargin";
import FixedCosts from "../Component/SalaryCalculation/FixedCosts";
import Measures from "../Component/SalaryCalculation/Measures";
import SurplusBeforeTax from "../Component/SalaryCalculation/SurplusBeforeTax";
import TemplatePayrollTax from "../Component/SalaryCalculation/TemplatePayrollTax";
import FixedEarnedIncome from "../Component/SalaryCalculation/FixedEarnedIncome";
import StandardTaxRelief from "../Component/SalaryCalculation/StandardTaxRelief";
import TaxableIncome from "../Component/SalaryCalculation/TaxableIncome";
import LocalTaxes from "../Component/SalaryCalculation/LocalTaxes";
import StateTax from "../Component/SalaryCalculation/StateTax";
import PayrollTax from "../Component/SalaryCalculation/PayrollTax";
import GeneralPension from "../Component/SalaryCalculation/GeneralPension";
import FuneralFees from "../Component/SalaryCalculation/FuneralFees";
import ReductionOfGeneralPension from "../Component/SalaryCalculation/ReductionOfGeneralPension";
import EarnedIncomeTax from "../Component/SalaryCalculation/EarnedIncomeTax";
import NetProfitPerMonth from "../Component/SalaryCalculation/NetProfitPerMonth";
import NetProfitPerYear from "../Component/SalaryCalculation/NetProfitPerYear";
// Ab
import GeneralPayrollTax from "../Component/SalaryCalculation/GeneralPayrollTax";
import GrossAnnualSalary from "../Component/SalaryCalculation/GrossAnnualSalary";
//test windowsize
import useWindowSize from "../Component/use-window-size";

export default function SalaryCalculation() {
  const [headingFocused, setHeadingFocused] = useState("");
  //get current windowsize
  const size = useWindowSize();

  //get current company form
  const activeCompany = useSelector((state) => state.companyForm);
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Lonekalkyl"));
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return (
    <div>
      <Row className="mt-5">
        <Col xs={size.width < sizeForMobile ? 0 : 20} className="m-auto g-0">
          {size.width < sizeForMobile ? (
            ""
          ) : (
            <Headings headingFocused={headingFocused} />
          )}
          <div
            className={
              size.width < sizeForMobile ? "scrollbox-mobile" : "scrollbox"
            }
          >
            <div className="content-wrapper">
              <div
                className={
                  size.width < sizeForMobile ? "container-input-mobile" : ""
                }
              >
                <YearsGrossMargin />
                <FixedCosts />
                <Measures />
                <SurplusBeforeTax />
                {/* 
              remove or not ??
              <NonTaxableIncomeLimit/> */}
                {activeCompany.companyForm === "enskildFirma" ? (
                  <>
                    <TemplatePayrollTax setHeadingFocused={setHeadingFocused} />
                    <FixedEarnedIncome />
                  </>
                ) : (
                  <>
                    <GeneralPayrollTax setHeadingFocused={setHeadingFocused} />
                    <GrossAnnualSalary />
                  </>
                )}

                <StandardTaxRelief setHeadingFocused={setHeadingFocused} />
                <TaxableIncome setHeadingFocused={setHeadingFocused} />
                <LocalTaxes setHeadingFocused={setHeadingFocused} />
                <StateTax setHeadingFocused={setHeadingFocused} />

                {activeCompany.companyForm === "aktiebolag" ? (
                  ""
                ) : (
                  <>
                    <PayrollTax setHeadingFocused={setHeadingFocused} />
                  </>
                )}

                <GeneralPension setHeadingFocused={setHeadingFocused} />
                <FuneralFees setHeadingFocused={setHeadingFocused} />
                <ReductionOfGeneralPension />
                <EarnedIncomeTax setHeadingFocused={setHeadingFocused} />
                <NetProfitPerYear />
                <NetProfitPerMonth />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
